import React from 'react'

/** A busy indicator. A bordered circle in a spin, rather than MUI's SVG and its theme lookup. */
function Spinner({ size = 16 }: { size?: number }) {
  return (
    <span
      aria-hidden
      className='inline-block shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent'
      style={{ width: size, height: size }}
    />
  )
}

Spinner.defaultProps = { size: 16 }

export default Spinner
